import { render, staticRenderFns } from "./salesRefundAccount.vue?vue&type=template&id=46ccddcb&scoped=true"
import script from "./salesRefundAccount.vue?vue&type=script&lang=js"
export * from "./salesRefundAccount.vue?vue&type=script&lang=js"
import style0 from "./salesRefundAccount.vue?vue&type=style&index=0&id=46ccddcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ccddcb",
  null
  
)

export default component.exports